import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    subject: {
      inputType: 'text',
      title: 'Subject',
      required: true,
    },
    content: {
      inputType: 'textarea',
      title: 'Content',
      required: true,
      rows: 15,
    },
    files: {
      inputType: 'filetable',
      title: 'Attachment Files',
      filePath: `broker/emails`,
      required: false,
      showStatus: false,
      showCategory: false,
      multiple: true,
    },
  }
}
